import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CustomButtonSecondary from '../../shared/atomic_components/button/CustomButtonSecondary';
import Modal from "@mui/material/Modal";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
};

type ModalAssegnaSegnalazioneInterface = {
    openModalAssegnaSegnalazione : any,
    handleCloseModalAssegnaSegnalazione : any
}

const ModalAssegnaSegnalazione = ({
                                      openModalAssegnaSegnalazione,
                                      handleCloseModalAssegnaSegnalazione} : ModalAssegnaSegnalazioneInterface) => {

    return (
        <Modal
            open={openModalAssegnaSegnalazione}
            onClose={handleCloseModalAssegnaSegnalazione}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyle}>
                <div className="font-large-custom">Assegna segnalazione</div>
                <div className="font-medium-custom mt-3 mb-3">Selezionare l'utente al quale assegnare la segnalazione</div>
                <FormControl className="mt-3" fullWidth>
                    <InputLabel id="demo-simple-select-label">Utente</InputLabel>
                    <Select
                        label="Utente">
                            <MenuItem value="Paolo Rossi">
                                Paolo Rossi
                            </MenuItem>
                            <MenuItem value="Mario Bianchi">
                                Mario Bianchi
                            </MenuItem>
                    </Select>
                </FormControl>
                <div className="mt-4 text-center col-12">
                    <CustomButtonSecondary onClick={() => {handleCloseModalAssegnaSegnalazione()}} variant="contained">Assegna</CustomButtonSecondary>
                </div>
            </Box>
        </Modal>
    );

}

export default ModalAssegnaSegnalazione;
